import styled from 'styled-components';

export const NotFoundPageContainer = styled.div`
  min-height: 100vh;
  background-color: oklch(1 0 0);
  direction: rtl;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NotFoundWrapper = styled.div`
  max-width: 820px;
  width: 100%;
  margin: 0 auto;
  padding: 24px 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 640px) {
    padding: 28px 24px;
  }

  @media (min-width: 1024px) {
    padding: 32px;
  }
`;

export const NotFoundCard = styled.div`
  background: oklch(1 0 0);
  border: 1px solid oklch(0.9288 0.0126 255.51);
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
`;

export const CardBody = styled.div`
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Hero = styled.div`
  text-align: center;
  padding: 20px 0;
`;

export const Number404 = styled.div`
  font-size: 120px;
  font-weight: 900;
  color: oklch(0.2264 0 0);
  line-height: 1;
  margin-bottom: 20px;
  font-family: inherit;

  @media (max-width: 640px) {
    font-size: 80px;
  }
`;

export const Title = styled.h1`
  margin: 20px 0 12px;
  font-size: 24px;
  font-weight: 900;
  color: oklch(0.2264 0 0);
  font-family: inherit;
`;

export const Subtitle = styled.p`
  margin: 12px 0 0;
  color: oklch(0.2264 0 0);
  font-weight: 500;
  font-size: 16px;
  line-height: 1.6;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
`;

export const Actions = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 500px;

  @media (min-width: 640px) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const PrimaryButton = styled.button`
  width: 100%;
  height: 45px;
  border-radius: 8px;
  border: 1px solid oklch(0.65 0.24 33.09);
  background: oklch(0.65 0.24 33.09);
  color: oklch(1 0 0);
  font-weight: 800;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 640px) {
    width: auto;
    min-width: 200px;
  }

  &:hover {
    background: oklch(0.6099 0.1961 32.31);
    border-color: oklch(0.6099 0.1961 32.31);
  }
`;

export const SecondaryButton = styled.button`
  width: 100%;
  height: 45px;
  border-radius: 8px;
  border: 1px solid oklch(0.9288 0.0126 255.51);
  background: oklch(1 0 0);
  color: oklch(0.2264 0 0);
  font-weight: 800;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 640px) {
    width: auto;
    min-width: 200px;
  }

  &:hover {
    background: oklch(1 0 0);
    border-color: oklch(0.869 0.0198 252.89);
  }
`;

